export enum TipoConvenioBoletoEnum {

  FEBRABAN_LEGADO,
  SICOB,
  SIGCB,
  SINCO
}
